import { BaseNode } from './BaseNode';

export function WebhookNode({ data }: { data: { label: string } }) {
  return <BaseNode type="webhook" label={data.label} hasTarget={false} lines={[{ text: 'Starts the flow' }]} />;
}
